import * as React from "react";
import { IntlIcon } from "@/components/IntlIcon";
import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  heading: React.ReactNode;
  body: React.ReactNode;
  className?: string;
}

const EmptyState = ({ icon, heading, body, className }: EmptyStateProps) => (
  <div className={cn("flex flex-col items-center justify-center gap-6 self-stretch p-12", className)}>
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
      {icon ?? <IntlIcon name="magnifying-glass" className="h-6 w-6 text-muted-foreground" />}
    </div>
    <div className="flex flex-col items-center gap-2 text-center">
      <h2 className="intl-heading-h2-upper text-foreground">{heading}</h2>
      <p className="intl-text-body-small max-w-md text-muted-foreground">{body}</p>
    </div>
  </div>
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
